import { IndustryRecipe } from "./IndustryRecipe";
import { useRef } from "react";

export const IndustryRecipes = ({ recipes }) => {
  const card = useRef(null);
  return (
    <section className="industry_recipes_section">
      <div className="industry_recipes_section-container">
        <h2>Recipes</h2>
        <p>
          Combine multiple data sources using templates pre-built by Demyst for getting started on
          common financial services problems.
        </p>
        <div className="industry_recipes_section-grid">
          {recipes.map(item => (
            <IndustryRecipe ref={card} key={item.title} {...item} />
          ))}
        </div>
      </div>
    </section>
  );
};
